// extracted by mini-css-extract-plugin
export var closeButton = "_fe-2";
export var closeButtonIcon = "_fe-3";
export var lightboxContent = "_fe-1";
export var lightboxOverlay = "_fe-0";